import React, { useEffect, useState } from "react";
import { Spinner, Button } from "react-bootstrap";
import { EmptyGuid } from "../../models";
import { SubmissionService } from "../../services/SubmissionService";
export default function Redirect() {
    // get the submission id from the url
    // the url will be in the form of /redirect/00000000-0000-0000-0000-000000000000
    // the submission id will be the last part of the url
    const submissionId = window.location.pathname.split("/").pop();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        if (!submissionId) {
            window.location.href = "/queue";
            return;
        }
        setLoading(true);
        SubmissionService.cancelHold({ submissionId }).then(
            (resp) => {
                if (resp.successful) {
                    setLoading(false);
                    window.location.href =
                        "/efile?submissionId=" + submissionId;
                } else {
                    setLoading(false);
                    setError(resp.errorMessage!);
                    console.log("This is reaching here");
                }
            },
            (error) => {
                setLoading(false);
                setError(error);
            }
        );
    }, [submissionId]);

    const handleClick = () => {
        setLoading(true);
        SubmissionService.cancelHold({ submissionId: submissionId ?? "" }).then(
            (resp) => {
                if (resp.successful) {
                    setLoading(false);
                    window.location.href =
                        "/efile?submissionId=" + submissionId;
                } else {
                    setLoading(false);
                    setError(resp.errorMessage!);
                    console.log("This is reaching here");
                }
            },
            (error) => {
                setLoading(false);
                setError(error);
            }
        );
    };

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">File</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">eFile</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        File
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {loading ? (
                    <div className="row">
                        <div className="col-12">
                            <span>Redirecting to eFile...</span>
                            <Spinner animation="border" />
                        </div>
                    </div>
                ) : (
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <span>
                                        An error occurred while loading the
                                        Submission:{" " + submissionId}
                                    </span>
                                    <br />
                                    <b>{error}</b>
                                    <Button
                                        variant="primary"
                                        onClick={handleClick}
                                    >
                                        Try Again
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
